import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import { type } from "os";
import { json } from "d3";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import InputMask from "../App/InputMask";
import {
  DownloadClientsDataInExcel,
  DownloadClientsDataInExcelWithBGColors,
  SortTheList,
  getAccessSettings,
  removeNonNumeric,
} from "../Shared/Utility";
import DonutChart from "../Charts/DonutChart";

function ProgramDashboardV2() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);
  const [showSummaryView, setShowSummaryView] = useState(true);

  const [programDashboardFilter, setProgramDashboardFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
  });

  const [programDashboardData, setProgramDashboardData] = useState({
    JaguarPOT: 0,
    LandRoverPOT: 0,
    JLRPOT: 0,
    JaguarFinalPayout: 0,
    LandRoverFinalPayout: 0,
    JLRFinalPayout: 0,
    JaguarFinalPayoutPercentage: 0,
    LandRoverFinalPayoutPercentage: 0,
    JLRFinalPayoutPercentage: 0,

    JaguarActualAchievement: 0,
    LandRoverActualAchievement: 0,
    JLRActualAchievement: 0,

    JaguarException: 0,
    LandRoverException: 0,
    JLRException: 0,

    JaguarConditionalHold: 0,
    LandRoverConditionalHold: 0,
    JLRConditionalHold: 0,

    JaguarActualAchievementPercentage: 0,
    LandRoverActualAchievementPercentage: 0,
    JLRActualAchievementPercentage: 0,

    JaguarExceptionPercentage: 0,
    LandRoverExceptionPercentage: 0,
    JLRExceptionPercentage: 0,

    JaguarConditionalHoldPercentage: 0,
    LandRoverConditionalHoldPercentage: 0,
    JLRConditionalHoldPercentage: 0,

    ImporterCount: 0,
    ImporterEligibleForRE: 0,
    GatewayCount: 0,
    ReEarnableCount: 0,
    ReEarnablePercentage: 0,

    PassAllReEaranables: 0,
    Fail1ReEaranables: 0,
    Fail2ReEaranables: 0,
    Fail3ReEaranables: 0,
    Fail4ReEaranables: 0,
  });

  const [programList, setProgramList] = useState<any>([]);
  const [programData, setProgramData] = useState({}) as any;

  const [programStageList, setProgramStageList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [quarterData, setQuarterData] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);
  const [importerListBK, setImporterListBK] = useState<any>([]);
  const [groupList, setGroupList] = useState<any>([]);

  const [sectionList, setSectionList] = useState<any>([]);
  const [sectionListBK, setSectionListBK] = useState<any>([]);
  const [criteriaList, setCriteriaList] = useState<any>([]);
  const [inputData, setInputData] = useState<any>([]);

  const [ReEarnableCount, setReEarnableCount] = useState<any>([
    { Name: "Direct Pass" },
    { Name: "Fail" },
    { Name: "Raised Exception" },
    { Name: "Approved Exception" },
    { Name: "Conditional Hold" },
  ]);

  const [ReEarnableCountStats, setReEarnableCountStats] = useState<any>([]);
  const [currentImporterPFIBrandID, setCurrentImporterPFIBrandID] = useState(2);
  const [showHTML, setShowHTML] = useState(false);

  useEffect(() => {
    if (
      getAccessSettings(2, 1) == 0 ||
      globalState.AppAccessLevelData.DID > 0
    ) {
      if (getAccessSettings(2, 3) == 0) window.location.href = "login";
      else window.location.href = "scorecard";
    } else setShowHTML(true);

    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
      setProgramDashboardFilter((prevState: any) => ({
        ...prevState,
        ProgramID: IBBProgramID,
      }));
      IBBProgramGetProgramListForScorecard(
        IBBProgramID,
        programDashboardFilter.QuarterID
      );
    } else
      IBBProgramGetProgramListForScorecard(
        programDashboardFilter.ProgramID,
        programDashboardFilter.QuarterID
      );

    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0) {
      setShowSummaryView(true);
      IBBProgramGetDataForProgramDashboard();
    }
  }, [
    programDashboardFilter.ProgramID,
    programDashboardFilter.QuarterID,
    programDashboardFilter.PFIGroupIDs,
  ]);

  useEffect(() => {
    if (programDashboardFilter.QuarterID > 0) {
      if (showSummaryView)
        formatSectionAndCriteriaInputDataForSummaryScorecard();
      else formatSectionAndCriteriaInputDataForDetailsScorecard();
    }
  }, [inputData, sectionList]);

  useEffect(() => {
    if (programDashboardFilter.QuarterID > 0) formatSectionDataForScorecard();
  }, [criteriaList]);

  useEffect(() => {
    if (programDashboardFilter.QuarterID > 0) {
      formatSectionDataForScorecard();
    }
  }, [showSummaryView]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programDashboardFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setProgramDashboardFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            let filtered = result[0].filter(
              (item: any) => item.IBBProgramID == IBBProgramID
            );
            if (filtered.length > 0) {
              setProgramData(filtered[0]);
            }

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setProgramDashboardFilter((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }

            setProgramStageList(result[result.length - 1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetDataForProgramDashboard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = programDashboardFilter.ProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    object.pfigroupids = programDashboardFilter.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetDataForProgramDashboardV2",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            let JaguarPOT = 0;
            let LandRoverPOT = 0;
            let JLRPOT = 0;
            let JaguarFinalPayout = 0;
            let LandRoverFinalPayout = 0;
            let JLRFinalPayout = 0;
            let JaguarFinalPayoutPercentage = 0;
            let LandRoverFinalPayoutPercentage = 0;
            let JLRFinalPayoutPercentage = 0;
            let GatewayCount = 0;
            let ReEarnableCount = 0;
            let ReEarnablePercentage = 0;
            let ImporterCount = 0;
            let ImporterEligibleForRE = 0;

            let PassAllReEaranables = 0;
            let Fail1ReEaranables = 0;
            let Fail2ReEaranables = 0;
            let Fail3ReEaranables = 0;
            let Fail4ReEaranables = 0;

            let JaguarActualAchievement = 0;
            let LandRoverActualAchievement = 0;
            let JLRActualAchievement = 0;

            let JaguarException = 0;
            let LandRoverException = 0;
            let JLRException = 0;

            let JaguarConditionalHold = 0;
            let LandRoverConditionalHold = 0;
            let JLRConditionalHold = 0;

            let JaguarActualAchievementPercentage = 0;
            let LandRoverActualAchievementPercentage = 0;
            let JLRActualAchievementPercentage = 0;

            let JaguarExceptionPercentage = 0;
            let LandRoverExceptionPercentage = 0;
            let JLRExceptionPercentage = 0;

            let JaguarConditionalHoldPercentage = 0;
            let LandRoverConditionalHoldPercentage = 0;
            let JLRConditionalHoldPercentage = 0;

            if (result[0].length > 0) {
              let calculatedData = result[result.length - 1][0];

              JaguarPOT = calculatedData.JaguarPOT;
              LandRoverPOT = calculatedData.LandRoverPOT;
              JLRPOT = calculatedData.JLRPOT;

              JaguarFinalPayout = calculatedData.JaguarFinalPayout;
              LandRoverFinalPayout = calculatedData.LandRoverFinalPayout;
              JLRFinalPayout = calculatedData.JLRFinalPayout;

              JaguarActualAchievement = calculatedData.JaguarActualAchievement;
              LandRoverActualAchievement =
                calculatedData.LandRoverActualAchievement;
              JLRActualAchievement = calculatedData.JLRActualAchievement;

              JaguarException = calculatedData.JaguarException;
              LandRoverException = calculatedData.LandRoverException;
              JLRException = calculatedData.JLRException;

              JaguarConditionalHold = calculatedData.JaguarConditionalHold;
              LandRoverConditionalHold =
                calculatedData.LandRoverConditionalHold;
              JLRConditionalHold = calculatedData.JLRConditionalHold;

              JaguarFinalPayoutPercentage =
                calculatedData.JaguarFinalPayoutPercentage;
              LandRoverFinalPayoutPercentage =
                calculatedData.LandRoverFinalPayoutPercentage;
              JLRFinalPayoutPercentage =
                calculatedData.JLRFinalPayoutPercentage;

              JaguarActualAchievementPercentage =
                calculatedData.JaguarActualAchievementPercentage;
              LandRoverActualAchievementPercentage =
                calculatedData.LandRoverActualAchievementPercentage;
              JLRActualAchievementPercentage =
                calculatedData.JLRActualAchievementPercentage;

              JaguarExceptionPercentage =
                calculatedData.JaguarExceptionPercentage;
              LandRoverExceptionPercentage =
                calculatedData.LandRoverExceptionPercentage;
              JLRExceptionPercentage = calculatedData.JLRExceptionPercentage;

              JaguarConditionalHoldPercentage =
                calculatedData.JaguarConditionalHoldPercentage;
              LandRoverConditionalHoldPercentage =
                calculatedData.LandRoverConditionalHoldPercentage;
              JLRConditionalHoldPercentage =
                calculatedData.JLRConditionalHoldPercentage;
            }

            ImporterCount = result[2].length;

            setProgramDashboardData((prevState: any) => ({
              ...prevState,
              JaguarPOT: JaguarPOT,
              LandRoverPOT: LandRoverPOT,
              JLRPOT: JLRPOT,

              JaguarFinalPayout: JaguarFinalPayout,
              LandRoverFinalPayout: LandRoverFinalPayout,
              JLRFinalPayout: JLRFinalPayout,

              JaguarActualAchievement: JaguarActualAchievement,
              LandRoverActualAchievement: LandRoverActualAchievement,
              JLRActualAchievement: JLRActualAchievement,

              JaguarException: JaguarException,
              LandRoverException: LandRoverException,
              JLRException: JLRException,

              JaguarConditionalHold: JaguarConditionalHold,
              LandRoverConditionalHold: LandRoverConditionalHold,
              JLRConditionalHold: JLRConditionalHold,

              JaguarFinalPayoutPercentage: JaguarFinalPayoutPercentage,
              LandRoverFinalPayoutPercentage: LandRoverFinalPayoutPercentage,
              JLRFinalPayoutPercentage: JLRFinalPayoutPercentage,

              JaguarActualAchievementPercentage:
                JaguarActualAchievementPercentage,
              LandRoverActualAchievementPercentage:
                LandRoverActualAchievementPercentage,
              JLRActualAchievementPercentage: JLRActualAchievementPercentage,

              JaguarExceptionPercentage: JaguarExceptionPercentage,
              LandRoverExceptionPercentage: LandRoverExceptionPercentage,
              JLRExceptionPercentage: JLRExceptionPercentage,

              JaguarConditionalHoldPercentage: JaguarConditionalHoldPercentage,
              LandRoverConditionalHoldPercentage:
                LandRoverConditionalHoldPercentage,
              JLRConditionalHoldPercentage: JLRConditionalHoldPercentage,

              PassAllReEaranables: PassAllReEaranables,
              Fail1ReEaranables: Fail1ReEaranables,
              Fail2ReEaranables: Fail2ReEaranables,
              Fail3ReEaranables: Fail3ReEaranables,
              Fail4ReEaranables: Fail4ReEaranables,
              ImporterCount: ImporterCount,
            }));

            setQuarterData(result[1]);
            setImporterList(result[2]);
            setImporterListBK(result[2]);

            if (result[2] != null && result[2].length == 1) {
              let PFIBrandID = result[2][0].PFIBrandID;
              setCurrentImporterPFIBrandID(PFIBrandID);
            } else {
              setCurrentImporterPFIBrandID(2);
            }

            if (programDashboardFilter.QuarterID > 0) {
              setSectionList(result[3]);
              setSectionListBK(result[3]);
              setCriteriaList(result[4]);
              setInputData(result[5]);
              setReEarnableCountStats(result[6]);
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function formatSectionDataForScorecard() {
    let sectionListLocal = [...sectionListBK];
    let sectionListLocalBK = [...sectionListBK];

    if (showSummaryView) {
      for (let i = 0; i < sectionListLocal.length; i++) {
        if (!sectionListLocal[i].ManuallyAdded) {
          let IBBProgramSectionID = sectionListLocal[i].IBBProgramSectionID;
          var filtered = criteriaList.filter(
            (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            if (
              sectionListLocal[i].AllOrNothing == 0 &&
              sectionListLocal[i].Type == 2
            ) {
              //MM:: It means its a split
              sectionListLocal.splice(i, 1);
              for (let j = 0; j < filtered.length; j++) {
                sectionListLocal.splice(i, 0, {
                  IBBProgramSectionID: filtered[j].IBBProgramCriteriaID,
                  Title: filtered[j].Title,
                  ShortTitle: filtered[j].Title,
                  Type: 2,
                  Value: filtered[j].SplitPercentage,
                  PTOrderBy: 0,
                  AllOrNothing: 0,
                  ManuallyAdded: true,
                });
              }
              i--;
            } else {
              sectionListLocal[i].CriteriaCount = filtered.length;
            }
          }
        }
      }
    } else {
      for (let i = 0; i < sectionListLocal.length; i++) {
        let IBBProgramSectionID = sectionListLocal[i].IBBProgramSectionID;
        var filtered = criteriaList.filter(
          (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
        );
        if (filtered.length > 0)
          sectionListLocal[i].CriteriaCount = filtered.length;
      }
    }

    let reEarnableCountLocal = [...ReEarnableCount];
    for (let i = 0; i < sectionListLocalBK.length; i++) {
      let IBBProgramSectionID = sectionListLocalBK[i].IBBProgramSectionID;
      var filtered = ReEarnableCountStats.filter(
        (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
      );
      if (filtered.length > 0) {
        let title =
          sectionListLocalBK[i].Title +
          "-" +
          sectionListLocalBK[i].IBBProgramSectionID +
          "-Count";
        reEarnableCountLocal[0][title] = filtered[0].DirectPass;
        reEarnableCountLocal[1][title] = filtered[0].Fails;
        reEarnableCountLocal[2][title] = filtered[0].RaisedExceptions;
        reEarnableCountLocal[3][title] = filtered[0].ApprovedExceptions;
        reEarnableCountLocal[4][title] = filtered[0].ConditionalHold;
      }
    }

    setReEarnableCount(reEarnableCountLocal);
    setSectionList(sectionListLocal);
  }

  function formatSectionAndCriteriaInputDataForSummaryScorecard() {
    let importerListLocal = [...importerListBK];

    let PassAllReEaranables = 0;
    let Fail1ReEaranables = 0;
    let Fail2ReEaranables = 0;
    let Fail3ReEaranables = 0;
    let Fail4ReEaranables = 0;

    for (let i = 0; i < importerListLocal.length; i++) {
      let failedCount = 0;
      for (let j = 0; j < sectionList.length; j++) {
        let IBBScorecardID = importerListLocal[i].IBBScorecardID;
        let PFIBrandID = importerListLocal[i].PFIBrandID;
        let IBBProgramSectionID = sectionList[j].IBBProgramSectionID;
        let ManuallyAdded = sectionList[j].ManuallyAdded;
        if (!ManuallyAdded) {
          let Title = sectionList[j].Title + "-" + IBBProgramSectionID;
          importerListLocal[i][Title] = -1;
          importerListLocal[i][Title + "Class"] = "";
          importerListLocal[i][Title + "Icon"] = "";

          var filtered = inputData.filter(
            (item: any) =>
              item.IBBScorecardID == IBBScorecardID &&
              item.IBBProgramSectionID == IBBProgramSectionID &&
              (item.PFIBrandID == PFIBrandID ||
                PFIBrandID == 2 ||
                item.PFIBrandID == 2)
          );
          if (filtered.length > 0) {
            var sortedData = SortTheList(
              filtered,
              "FinalResultForColorCoding",
              "D"
            );
            let sectionStatus = sortedData[0].FinalResultForColorCoding;

            importerListLocal[i][Title] = sectionStatus;
            if (sectionStatus == 9 || sectionStatus == 6 || sectionStatus == 4)
              importerListLocal[i][Title + "Class"] = "RedClass";
            if (sectionStatus == 2 || sectionStatus == 1)
              importerListLocal[i][Title + "Class"] = "GreenClass";
            if (sectionStatus == 10 || sectionStatus == 7)
              importerListLocal[i][Title + "Class"] = "OrangeClass";
            if (sectionStatus == 8 || sectionStatus == 5)
              importerListLocal[i][Title + "Class"] = "BlueClass";
            if (
              sectionStatus == 10 ||
              sectionStatus == 9 ||
              sectionStatus == 8
            ) {
              importerListLocal[i][Title + "Icon"] = "images/hold.svg";
              importerListLocal[i][Title + "Class"] += " text-center";
            }
            if (
              sectionStatus == 7 ||
              sectionStatus == 6 ||
              sectionStatus == 5
            ) {
              importerListLocal[i][Title + "Icon"] = "images/exception.svg";
              importerListLocal[i][Title + "Class"] += " text-center";
            }
          }

          filtered = inputData.filter(
            (item: any) =>
              item.IBBScorecardID == IBBScorecardID &&
              item.IBBProgramSectionID == IBBProgramSectionID &&
              (item.PFIBrandID == PFIBrandID ||
                PFIBrandID == 2 ||
                item.PFIBrandID == 2) &&
              (item.InitialResult == 0 ||
                item.FinalResult == 0 ||
                item.FinalResult == 3 ||
                item.FinalResult == 4)
          );
          if (filtered.length > 0) failedCount++;
        } else {
          let Title = sectionList[j].Title + "-" + IBBProgramSectionID;
          importerListLocal[i][Title] = -1;
          var filtered = inputData.filter(
            (item: any) =>
              item.IBBScorecardID == IBBScorecardID &&
              item.IBBProgramCriteriaID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            importerListLocal[i][Title] = filtered[0].FinalResult;
            if (
              filtered[0].InitialResult == 0 ||
              filtered[0].FinalResult == 0 ||
              filtered[0].FinalResult == 3 ||
              filtered[0].FinalResult == 4
            )
              failedCount++;
          }
        }
      }
      if (failedCount == 0) PassAllReEaranables++;
      else if (failedCount == 1) Fail1ReEaranables++;
      else if (failedCount == 2) Fail2ReEaranables++;
      else if (failedCount == 3) Fail3ReEaranables++;
      else if (failedCount >= 4) Fail4ReEaranables++;

      //console.log(importerListLocal[i].DealerName+ ' -- '+failedCount);
    }

    setProgramDashboardData((prevState: any) => ({
      ...prevState,
      PassAllReEaranables: PassAllReEaranables,
      Fail1ReEaranables: Fail1ReEaranables,
      Fail2ReEaranables: Fail2ReEaranables,
      Fail3ReEaranables: Fail3ReEaranables,
      Fail4ReEaranables: Fail4ReEaranables,
    }));

    setImporterList(importerListLocal);
  }

  function formatSectionAndCriteriaInputDataForDetailsScorecard() {
    let importerListLocal = [...importerListBK];
    for (let i = 0; i < importerListLocal.length; i++) {
      for (let j = 0; j < criteriaList.length; j++) {
        let IBBScorecardID = importerListLocal[i].IBBScorecardID;
        let IBBProgramCriteriaID = criteriaList[j].IBBProgramCriteriaID;
        let Title = criteriaList[j].Title;

        importerListLocal[i][Title] = -1;
        importerListLocal[i][Title + "Class"] = "";
        importerListLocal[i][Title + "Icon"] = "";

        var filtered = inputData.filter(
          (item: any) =>
            item.IBBScorecardID == IBBScorecardID &&
            item.IBBProgramCriteriaID == IBBProgramCriteriaID
        );
        if (filtered.length > 0) {
          var sortedData = SortTheList(
            filtered,
            "FinalResultForColorCoding",
            "D"
          );
          let sectionStatus = sortedData[0].FinalResultForColorCoding;

          importerListLocal[i][Title] = sectionStatus;
          if (sectionStatus == 9 || sectionStatus == 6 || sectionStatus == 4)
            importerListLocal[i][Title + "Class"] = "RedClass";
          if (sectionStatus == 2 || sectionStatus == 1)
            importerListLocal[i][Title + "Class"] = "GreenClass";
          if (sectionStatus == 10 || sectionStatus == 7)
            importerListLocal[i][Title + "Class"] = "OrangeClass";
          if (sectionStatus == 8 || sectionStatus == 5)
            importerListLocal[i][Title + "Class"] = "BlueClass";
          if (sectionStatus == 10 || sectionStatus == 9 || sectionStatus == 8) {
            importerListLocal[i][Title + "Icon"] = "images/hold.svg";
            importerListLocal[i][Title + "Class"] += " text-center";
          }
          if (sectionStatus == 7 || sectionStatus == 6 || sectionStatus == 5) {
            importerListLocal[i][Title + "Icon"] = "images/exception.svg";
            importerListLocal[i][Title + "Class"] += " text-center";
          }
        }
      }
    }

    setImporterList(importerListLocal);
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>VRM Programs</a>
        </div>
        {showHTML && (
          <div className="page--data">
            <div className="flex-container">
              <div>
                <select
                  className="select-md"
                  value={programDashboardFilter.ProgramID}
                  onChange={(e) => {
                    setProgramDashboardFilter((prevState: any) => ({
                      ...prevState,
                      ProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      IBBProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    IBBProgramGetProgramListForScorecard(
                      Number(e.target.value),
                      0
                    );
                  }}
                >
                  {programList &&
                    programList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"programoption" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <select
                  style={{ marginLeft: 5 }}
                  className="select-md"
                  value={programDashboardFilter.QuarterID}
                  onChange={(e) => {
                    setProgramDashboardFilter((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                  }}
                >
                  {/* <option value={0} key={"quarteroption" + 0}>
                YTD
              </option> */}
                  {quarterList &&
                    quarterList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"quarteroption" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>

              <select
                className="select-md"
                value={programDashboardFilter.PFIGroupIDs}
                onChange={(e) =>
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                  }))
                }
              >
                {groupList &&
                  groupList.map((Item: any, index: any) => (
                    <option value={Item.IBBGroupID} key={"groupoption" + index}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
              <span></span>
            </div>

            <div className="db-new-fr-1">
              <div className="pot-fp fix-width-boxes">
                <div className="boxes-fr-1">
                  <div className="flex-boxes-fr">
                    <div className="re-earn">
                      <span className="re-val1">
                        <span>FUND AVAILABLE</span>
                      </span>
                      <span className="re-val2">
                        $
                        {programDashboardData.JLRPOT?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </span>
                    </div>
                    <div className="">
                      {/* {Number(programDashboardData.FinalPayoutPercentage).toFixed(2)}% */}
                      <DonutChart
                        data={[
                          {
                            name: "Achieved",
                            value:
                              programDashboardData.JLRFinalPayoutPercentage?.toLocaleString(
                                undefined,
                                { minimumFractionDigits: 2 }
                              ),
                            color: "#98cb4a",
                          },
                          {
                            name: "Not Achieved",
                            value:
                              100 -
                              Number(
                                programDashboardData.JLRFinalPayoutPercentage
                              ),
                            color: "#f5f5f5",
                          },
                        ]}
                        totalValueToPrint={
                          programDashboardData.JLRFinalPayoutPercentage?.toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2 }
                          ) + "%"
                        }
                        showTextOnGraph={0}
                        innerRadius={1.2}
                      ></DonutChart>
                    </div>
                    <div className="re-earn">
                      <span className="re-val1">FINAL ACHIEVEMENT</span>
                      <span className="re-val2">
                        $
                        {programDashboardData.JLRFinalPayout?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="boxes-fr-3">
                    <div className="re-earn">
                      <span className="re-val1">$ INITIAL ACHIEVEMENT</span>
                      <span className="re-val2">
                        $
                        {programDashboardData.JLRActualAchievement?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </span>
                    </div>
                    <div className="re-earn">
                      <span className="re-val1">$ Exception</span>
                      <span className="re-val2">
                        $
                        {programDashboardData.JLRException?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </span>
                    </div>
                    <div className="re-earn">
                      <span className="re-val1">$ Conditional Hold</span>
                      <span className="re-val2">
                        $
                        {programDashboardData.JLRConditionalHold?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </span>
                    </div>

                    <div className="re-earn">
                      <span className="re-val1">% INITIAL ACHIEVEMENT</span>
                      <span className="re-val2">
                        {programDashboardData.JLRActualAchievementPercentage?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                        %
                      </span>
                    </div>
                    <div className="re-earn">
                      <span className="re-val1">% Exception</span>
                      <span className="re-val2">
                        {programDashboardData.JLRExceptionPercentage?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                        %
                      </span>
                    </div>
                    <div className="re-earn">
                      <span className="re-val1">% Conditional Hold</span>
                      <span className="re-val2">
                        {programDashboardData.JLRConditionalHoldPercentage?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                        %
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {(currentImporterPFIBrandID == 2 ||
                currentImporterPFIBrandID == 3) && (
                <div className="pot-fp fix-width-boxes light-box">
                  <div className="boxes-fr-1">
                    <span className="j-title">PFI Brand 3</span> 
                    <div className="flex-boxes-fr">
                      <div className="re-earn">
                        <span className="re-val1">
                          <span>FUND AVAILABLE</span>
                        </span>
                        <span className="re-val2">
                          $
                          {programDashboardData.JaguarPOT?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="">
                        <DonutChart
                          data={[
                            {
                              name: "Achieved",
                              value:
                                programDashboardData.JaguarFinalPayoutPercentage?.toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 }
                                ),
                              color: "#98cb4a",
                            },
                            {
                              name: "Not Achieved",
                              value:
                                100 -
                                Number(
                                  programDashboardData.JaguarFinalPayoutPercentage
                                ),
                              color: "#f5f5f5",
                            },
                          ]}
                          totalValueToPrint={
                            programDashboardData.JaguarFinalPayoutPercentage?.toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2 }
                            ) + "%"
                          }
                          showTextOnGraph={0}
                          innerRadius={1.2}
                        ></DonutChart>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">FINAL ACHIEVEMENT</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.JaguarFinalPayout?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="boxes-fr-3">
                      <div className="re-earn">
                        <span className="re-val1">$ INITIAL Achievement</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.JaguarActualAchievement?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">$ Exception</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.JaguarException?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">$ Conditional Hold</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.JaguarConditionalHold?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>

                      <div className="re-earn">
                        <span className="re-val1">% INITIAL Achievement</span>
                        <span className="re-val2">
                          {programDashboardData.JaguarActualAchievementPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">% Exception</span>
                        <span className="re-val2">
                          {programDashboardData.JaguarExceptionPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">% Conditional Hold</span>
                        <span className="re-val2">
                          {programDashboardData.JaguarConditionalHoldPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {(currentImporterPFIBrandID == 2 ||
                currentImporterPFIBrandID == 4) && (
                <div className="pot-fp fix-width-boxes light-box">
                  <div className="boxes-fr-1">
                    <span className="j-title"> PFI Brand 4</span>
                    <div className="flex-boxes-fr">
                      <div className="re-earn">
                        <span className="re-val1">
                          <span>FUND AVAILABLE</span>
                        </span>
                        <span className="re-val2">
                          $
                          {programDashboardData.LandRoverPOT?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="">
                        <DonutChart
                          data={[
                            {
                              name: "Achieved",
                              value:
                                programDashboardData.LandRoverFinalPayoutPercentage?.toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 }
                                ),
                              color: "#98cb4a",
                            },
                            {
                              name: "Not Achieved",
                              value:
                                100 -
                                Number(
                                  programDashboardData.LandRoverFinalPayoutPercentage
                                ),
                              color: "#f5f5f5",
                            },
                          ]}
                          totalValueToPrint={
                            programDashboardData.LandRoverFinalPayoutPercentage?.toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2 }
                            ) + "%"
                          }
                          showTextOnGraph={0}
                          innerRadius={1.2}
                        ></DonutChart>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">FINAL ACHIEVEMENT</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.LandRoverFinalPayout?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="boxes-fr-3">
                      <div className="re-earn">
                        <span className="re-val1">$ INITIAL ACHIEVEMENT</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.LandRoverActualAchievement?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">$ Exception</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.LandRoverException?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">$ Conditional Hold</span>
                        <span className="re-val2">
                          $
                          {programDashboardData.LandRoverConditionalHold?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>

                      <div className="re-earn">
                        <span className="re-val1">% INITIAL ACHIEVEMENT</span>
                        <span className="re-val2">
                          {programDashboardData.LandRoverActualAchievementPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">% Exception</span>
                        <span className="re-val2">
                          {programDashboardData.LandRoverExceptionPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                      <div className="re-earn">
                        <span className="re-val1">% Conditional Hold</span>
                        <span className="re-val2">
                          {programDashboardData.LandRoverConditionalHoldPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          %
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="idb-grid no-display">
              <div className="idb-grid-right">
                {programDashboardFilter.QuarterID == 0 && (
                  <div className="q-boxes">
                    {quarterData &&
                      quarterData.map((Item: any, index: any) => (
                        <div className="q-box-s" key={"quarterview" + index}>
                          <div className="q-head">{Item.Name}</div>
                          {Item.POT > 0 && (
                            <div className="pot-fp fix-width-boxes">
                              <div className="re-earn">
                                <span className="re-val1">
                                  <span>POT</span>
                                </span>
                                <span className="re-val2">
                                  $
                                  {Item.POT?.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}
                                </span>
                              </div>
                              <div className="pot-per">
                                <DonutChart
                                  data={[
                                    {
                                      name: "Achieved",
                                      value: Number(
                                        (Item.FinalPayout / Item.POT) * 100
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                      color: "#98cb4a",
                                    },
                                    {
                                      name: "Not Achieved",
                                      value:
                                        100 -
                                        Number(
                                          (Item.FinalPayout / Item.POT) * 100
                                        ),
                                      color: "#f5f5f5",
                                    },
                                  ]}
                                  totalValueToPrint={
                                    Number(
                                      (Item.FinalPayout / Item.POT) * 100
                                    )?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) + "%"
                                  }
                                  showTextOnGraph={0}
                                  innerRadius={1.2}
                                ></DonutChart>
                              </div>

                              <div className="re-earn">
                                <span className="re-val1">
                                  FINAL ACHIEVEMENT
                                </span>
                                <span className="re-val2">
                                  $
                                  {Item.FinalPayout?.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}
                                </span>
                              </div>
                              <div className="excp-left">
                                <div className="excp-1">
                                  <img
                                    src="images/excp.svg"
                                    width="24px"
                                    height="24px"
                                  />
                                  <span>Exceptions</span>
                                </div>
                                <div className="excp-2">
                                  <span className="e-y">
                                    <a
                                      title="View"
                                      href={
                                        "exceptions?pid=" +
                                        programDashboardFilter.ProgramID +
                                        "&qid=" +
                                        Item.PID +
                                        "&exsid=0"
                                      }
                                    >
                                      {Item.InProgressExceptionCount > 0 && (
                                        <>{Item.InProgressExceptionCount}</>
                                      )}
                                    </a>
                                  </span>
                                  <span className="e-g">
                                    <a
                                      title="View"
                                      href={
                                        "exceptions?pid=" +
                                        programDashboardFilter.ProgramID +
                                        "&qid=" +
                                        Item.PID +
                                        "&exsid=1"
                                      }
                                    >
                                      {Item.ApprovedExceptionCount > 0 && (
                                        <>{Item.ApprovedExceptionCount}</>
                                      )}
                                    </a>
                                  </span>
                                  <span className="e-r">
                                    <a
                                      title="View"
                                      href={
                                        "exceptions?pid=" +
                                        programDashboardFilter.ProgramID +
                                        "&qid=" +
                                        Item.PID +
                                        "&exsid=2"
                                      }
                                    >
                                      {Item.RejectedExceptionCount > 0 && (
                                        <>{Item.RejectedExceptionCount}</>
                                      )}
                                    </a>
                                  </span>
                                </div>
                              </div>
                              {/* <div className="q-status">
                            <span>Status</span>
                            <span>Completed</span>
                          </div> */}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
            <div className="fr-13 fr-13-bpm">
              <div className="flex-container">
                <span></span>
                <a
                  title="Export Criteria Pass Fail Counts"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblIBBCriteria",
                      "Criteria Pass Fail Counts"
                    )
                  }
                >
                  <img src="images/export-b.svg" width="18" height="18" />
                </a>
              </div>
              {programDashboardFilter.QuarterID > 0 && (
                <div className="flex-container">
                  <span></span>

                  <a
                    title="Export Criteria Status Counts"
                    onClick={() =>
                      DownloadClientsDataInExcel(
                        "tblIBBCriteriaProgram",
                        "Criteria Status Counts"
                      )
                    }
                  >
                    <img src="images/export-b.svg" width="18" height="18" />
                  </a>
                </div>
              )}
            </div>

            <div className="fr-13">
              <div
                className="section-table b-white"
                style={{ boxShadow: "none", padding: 0, minWidth: 260 }}
              >
                <table
                  className="part-head trend-table fixed-table auto-table"
                  id="tblIBBCriteria"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Number of Importers</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Pass all Criteria</td>
                      <td className="text-right">
                        {programDashboardData.PassAllReEaranables}
                      </td>
                    </tr>
                    <tr>
                      <td>Fail 1 Criteria</td>
                      <td className="text-right">
                        {programDashboardData.Fail1ReEaranables}
                      </td>
                    </tr>
                    <tr>
                      <td>Fail 2 Criteria</td>
                      <td className="text-right">
                        {programDashboardData.Fail2ReEaranables}
                      </td>
                    </tr>
                    <tr>
                      <td>Fail 3 Criteria</td>
                      <td className="text-right">
                        {programDashboardData.Fail3ReEaranables}
                      </td>
                    </tr>
                    <tr>
                      <td>Fail 4 Criteria</td>
                      <td className="text-right">
                        {programDashboardData.Fail4ReEaranables}
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td className="text-right">
                        {programDashboardData.PassAllReEaranables +
                          programDashboardData.Fail1ReEaranables +
                          programDashboardData.Fail2ReEaranables +
                          programDashboardData.Fail3ReEaranables +
                          programDashboardData.Fail4ReEaranables}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {programDashboardFilter.QuarterID > 0 && (
                <div
                  className="section-table tab-summ blue-head b-white"
                  style={{ boxShadow: "none", padding: 0 }}
                >
                  <table
                    className="part-head trend-table fixed-table auto-table"
                    id="tblIBBCriteriaProgram"
                  >
                    <thead>
                      <tr>
                        <th className="clip-box">CRITERIA</th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              {item.Type == 2 && <th>{item.ShortTitle}</th>}
                            </React.Fragment>
                          ))}
                      </tr>
                      <tr>
                        <th className="clip-box">WEIGHTING</th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              {item.Type == 2 && (
                                <th>
                                  {item.Value?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                  %
                                </th>
                              )}
                            </React.Fragment>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {ReEarnableCount &&
                        ReEarnableCount.map((item: any, index: any) => (
                          <React.Fragment key={"ReEarnableCount" + index}>
                            <tr>
                              <td>{item.Name}</td>
                              {sectionList &&
                                sectionList.map(
                                  (sectionItem: any, sectionIndex: any) => (
                                    <React.Fragment
                                      key={
                                        "ReEarnableCount" +
                                        index +
                                        "" +
                                        sectionIndex
                                      }
                                    >
                                      {sectionItem.Type == 2 && (
                                        <td className="text-right">
                                          {
                                            item[
                                              sectionItem.Title +
                                                "-" +
                                                sectionItem.IBBProgramSectionID +
                                                "-Count"
                                            ]
                                          }
                                        </td>
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {programDashboardFilter.QuarterID > 0 && showSummaryView && (
              <>
                <div className="flex-container export-svg-2">
                  <span></span>
                  <a
                    title="Export Criteria Status Summary"
                    onClick={() =>
                      DownloadClientsDataInExcelWithBGColors(
                        "tblIBBPROGRAMSMainSummary",
                        "Criteria Status Summary"
                      )
                    }
                  >
                    <img src="images/export-b.svg" width="18" height="18" />
                  </a>
                </div>
                <div
                  className="section-table tab-summ table-ch-bottom b-white"
                  style={{ boxShadow: "none", padding: 0 }}
                >
                  <table className="part-head trend-table fixed-table auto-table">
                    <thead>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {sectionList &&
                          sectionList.length > 0 &&
                          sectionList[0].Type == 1 &&
                          sectionList[0].CriteriaCount > 0 && <th>GATEWAY</th>}
                        <th
                          colSpan={
                            sectionList.length -
                            (programDashboardData.GatewayCount > 0 ? 1 : 0)
                          }
                        >
                          CRITERIA
                        </th>
                        <th colSpan={3}></th>
                      </tr>
                      <tr className="h-41">
                        <th className="clip-box th-ch-pad" colSpan={2}>
                          <div className="flex-hold">
                            <span></span>
                            <a
                              className="show-summary"
                              onClick={(e) => {
                                setShowSummaryView(false);
                              }}
                            >
                              Details
                            </a>
                          </div>
                        </th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              <th>
                                {item.ShortTitle}&nbsp;
                                {item.Type == 2 && (
                                  <>
                                    {item.Value?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })}
                                    %
                                  </>
                                )}
                              </th>
                            </React.Fragment>
                          ))}
                        <th>Total POT</th>
                        <th>$ PAY-OUT</th>
                        <th>PAY-OUT %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importerList &&
                        importerList.map((item: any, index: any) => (
                          <React.Fragment key={"importerscorecard" + index}>
                            <tr>
                              <td>{item.MarketName}</td>
                              <td>
                                <div className="flex-td-in">
                                  {item.DealerName}
                                  <a
                                    className=""
                                    title="View"
                                    href={
                                      "scorecard?pid=" +
                                      programDashboardFilter.ProgramID +
                                      "&qid=" +
                                      programDashboardFilter.QuarterID +
                                      "&scid=" +
                                      item.PID //+"&dlid=" + item.PFIDealerID
                                    }
                                  >
                                    <img
                                      src="images/eye-blue.svg"
                                      width={20}
                                      height={20}
                                    />
                                  </a>
                                </div>
                              </td>

                              {sectionList &&
                                sectionList.map(
                                  (sectionItem: any, sectionIndex: any) => (
                                    <React.Fragment
                                      key={
                                        "sectionscorecarddata" +
                                        index +
                                        "" +
                                        sectionIndex
                                      }
                                    >
                                      <td
                                        className={
                                          item[
                                            sectionItem.Title +
                                              "-" +
                                              sectionItem.IBBProgramSectionID +
                                              "Class"
                                          ]
                                        }
                                      >
                                        {item[
                                          sectionItem.Title +
                                            "-" +
                                            sectionItem.IBBProgramSectionID +
                                            "Icon"
                                        ] != null &&
                                          item[
                                            sectionItem.Title +
                                              "-" +
                                              sectionItem.IBBProgramSectionID +
                                              "Icon"
                                          ] != "" && (
                                            <img
                                              src={
                                                item[
                                                  sectionItem.Title +
                                                    "-" +
                                                    sectionItem.IBBProgramSectionID +
                                                    "Icon"
                                                ]
                                              }
                                              width={18}
                                              height={19}
                                            />
                                          )}
                                      </td>
                                    </React.Fragment>
                                  )
                                )}
                              <td className="text-right-m">
                                $
                                {item.POT?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.FinalPayout?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                {item.JLRPercentage?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                                %
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>

                  <table
                    className="part-head trend-table fixed-table auto-table no-display"
                    id="tblIBBPROGRAMSMainSummary"
                  >
                    <thead>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {sectionList &&
                          sectionList.length > 0 &&
                          sectionList[0].Type == 1 &&
                          sectionList[0].CriteriaCount > 0 && <th>GATEWAY</th>}
                        <th
                          colSpan={
                            sectionList.length -
                            (programDashboardData.GatewayCount > 0 ? 1 : 0)
                          }
                        >
                          CRITERIA
                        </th>
                        <th colSpan={3}></th>
                      </tr>
                      <tr className="h-41">
                        <th className="clip-box th-ch-pad" colSpan={2}>
                          {/* <div className="flex-hold">
                          <span></span>
                          <a
                            className="show-summary"
                            onClick={(e) => {
                              setShowSummaryView(false);
                            }}
                          >
                            Details
                          </a>
                        </div> */}
                        </th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              <th>
                                {item.ShortTitle}&nbsp;
                                {item.Type == 2 && (
                                  <>
                                    {item.Value?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })}
                                    %
                                  </>
                                )}
                              </th>
                            </React.Fragment>
                          ))}
                        <th>Total POT</th>
                        <th>$ PAY-OUT</th>
                        <th>PAY-OUT %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importerList &&
                        importerList.map((item: any, index: any) => (
                          <React.Fragment key={"importerscorecard" + index}>
                            <tr>
                              <td>{item.MarketName}</td>
                              <td>
                                <div className="flex-td-in">
                                  {item.DealerName}
                                  {/* <a
                                  className=""
                                  title="View"
                                  href={
                                    "scorecard?pid=" +
                                    programDashboardFilter.ProgramID +
                                    "&qid=" +
                                    programDashboardFilter.QuarterID +
                                    "&scid=" +
                                    item.PID //+"&dlid=" + item.PFIDealerID
                                  }
                                >
                                  <img
                                    src="images/eye-blue.svg"
                                    width={20}
                                    height={20}
                                  />
                                </a> */}
                                </div>
                              </td>

                              {sectionList &&
                                sectionList.map(
                                  (sectionItem: any, sectionIndex: any) => (
                                    <React.Fragment
                                      key={
                                        "sectionscorecarddata" +
                                        index +
                                        "" +
                                        sectionIndex
                                      }
                                    >
                                      <td
                                        className={
                                          item[
                                            sectionItem.Title +
                                              "-" +
                                              sectionItem.IBBProgramSectionID +
                                              "Class"
                                          ]
                                        }
                                      >
                                        {item[
                                          sectionItem.Title +
                                            "-" +
                                            sectionItem.IBBProgramSectionID +
                                            "Icon"
                                        ] != "" && (
                                          // <img
                                          //   src={
                                          //     item[
                                          //       sectionItem.Title +
                                          //         "-" +
                                          //         sectionItem.IBBProgramSectionID +
                                          //         "Icon"
                                          //     ]
                                          //   }
                                          //   width={18}
                                          //   height={19}
                                          // />

                                          <>
                                            {item[
                                              sectionItem.Title +
                                                "-" +
                                                sectionItem.IBBProgramSectionID +
                                                "Icon"
                                            ] == "images/exception.svg" && (
                                              <>&#9888;</>
                                            )}

                                            {item[
                                              sectionItem.Title +
                                                "-" +
                                                sectionItem.IBBProgramSectionID +
                                                "Icon"
                                            ] == "images/hold.svg" && (
                                              <>&#129306;</>
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </React.Fragment>
                                  )
                                )}
                              <td className="text-right-m">
                                $
                                {item.POT?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.FinalPayout?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                {item.JLRPercentage?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                                %
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}

                      <tr></tr>
                      <tr></tr>
                      <tr></tr>
                      <tr>
                        <th className="ib-red"></th>
                        <th colSpan={2}>Direct Fail</th>
                        <th className="ib-blue">&#9888;</th>
                        <th colSpan={2}>Exception raised</th>
                        <th className="ib-blue">&#129306;</th>
                        <th colSpan={3}>
                          Exception granted with conditional hold
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={10}></th>
                      </tr>
                      <tr>
                        <th className="ib-green"></th>
                        <th colSpan={2}>Direct pass on NA</th>
                        <th className="ib-red">&#9888;</th>
                        <th colSpan={2}>Exception rejected</th>
                        <th className="ib-red">&#129306;</th>
                        <th colSpan={3}>Conditional hold failed</th>
                      </tr>
                      <tr>
                        <th colSpan={10}></th>
                      </tr>
                      <tr>
                        <th colSpan={3}></th>
                        <th className="ib-amber">&#9888;</th>
                        <th colSpan={2}>Exception approved</th>
                        <th className="ib-amber">&#129306;</th>
                        <th colSpan={3}>Conditional hold passed</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {programDashboardFilter.QuarterID > 0 && !showSummaryView && (
              <>
                <div className="flex-container export-svg-2">
                  <span></span>
                  <a
                    title="Export Criteria Status Details"
                    onClick={() =>
                      DownloadClientsDataInExcelWithBGColors(
                        "tblIBBPROGRAMSMainDetail",
                        "Criteria Status Details"
                      )
                    }
                  >
                    <img src="images/export-b.svg" width="18" height="18" />
                  </a>
                </div>
                <div
                  className="section-table tab-det table-ch-bottom b-white"
                  style={{ boxShadow: "none", padding: 0 }}
                >
                  <table className="part-head trend-table fixed-table auto-table">
                    <thead>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {sectionList &&
                          sectionList.length > 0 &&
                          sectionList[0].Type == 1 &&
                          sectionList[0].CriteriaCount > 0 && (
                            <th colSpan={sectionList[0].CriteriaCount}>
                              GATEWAY
                            </th>
                          )}
                        <th
                          colSpan={
                            criteriaList.length -
                            (programDashboardData.GatewayCount > 0
                              ? programDashboardData.GatewayCount
                              : 0)
                          }
                        >
                          CRITERIA
                        </th>
                        <th colSpan={7}></th>
                      </tr>
                      <tr className="h-41">
                        <th className="clip-box" colSpan={2}>
                          <div className="flex-hold">
                            <span></span>
                            <a
                              className="show-summary"
                              onClick={(e) => {
                                setShowSummaryView(true);
                              }}
                            >
                              Summary
                            </a>
                          </div>
                        </th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              {item.CriteriaCount > 0 && (
                                <th colSpan={item.CriteriaCount}>
                                  {item.ShortTitle}&nbsp;
                                  {item.Type == 2 && (
                                    <>
                                      {item.Value?.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                      })}
                                      %
                                    </>
                                  )}
                                </th>
                              )}
                            </React.Fragment>
                          ))}
                        <th>Total POT</th>
                        <th colSpan={6}>$ PAY-OUT</th>
                      </tr>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {criteriaList &&
                          criteriaList.map((item: any, index: any) => (
                            <React.Fragment key={"criteriaheading" + index}>
                              <th>{item.Title}</th>
                            </React.Fragment>
                          ))}
                        <th colSpan={1}>All Brands</th>
                        <th colSpan={2}>PFI Brand 3</th>
                        <th colSpan={2}>PFI Brand 4</th>
                        <th colSpan={2}>All Brands</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importerList &&
                        importerList.map((item: any, index: any) => (
                          <React.Fragment key={"importerscorecard" + index}>
                            <tr>
                              <td>{item.MarketName}</td>
                              <td>
                                <div className="flex-td-in">
                                  {item.DealerName}
                                  <a
                                    className=""
                                    title="View"
                                    href={
                                      "scorecard?pid=" +
                                      programDashboardFilter.ProgramID +
                                      "&qid=" +
                                      programDashboardFilter.QuarterID +
                                      "&scid=" +
                                      item.PID //+"&dlid=" + item.PFIDealerID
                                    }
                                  >
                                    <img
                                      src="images/eye-blue.svg"
                                      width={20}
                                      height={20}
                                    />
                                  </a>
                                </div>
                              </td>

                              {criteriaList &&
                                criteriaList.map(
                                  (criteriaItem: any, criteriaIndex: any) => (
                                    <React.Fragment
                                      key={
                                        "criteriascorecarddata" +
                                        index +
                                        "" +
                                        criteriaIndex
                                      }
                                    >
                                      <td
                                        className={
                                          item[criteriaItem.Title + "Class"]
                                        }
                                      >
                                        {item[criteriaItem.Title + "Icon"] !=
                                          null &&
                                          item[criteriaItem.Title + "Icon"] !=
                                            "" && (
                                            <img
                                              src={
                                                item[
                                                  criteriaItem.Title + "Icon"
                                                ]
                                              }
                                              width={18}
                                              height={19}
                                            />
                                          )}
                                      </td>
                                    </React.Fragment>
                                  )
                                )}
                              <td className="text-right-m">
                                $
                                {item.POT?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.JaguarFinalPayoutInUSD?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.JaguarExceptionPayout?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.LandRoverFinalPayoutInUSD?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.LandRoverExceptionPayout?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.FinalPayout?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {(
                                  item.JaguarExceptionPayout +
                                  item.LandRoverExceptionPayout
                                )?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>

                  <table
                    className="part-head trend-table fixed-table auto-table no-display"
                    id="tblIBBPROGRAMSMainDetail"
                  >
                    <thead>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {sectionList &&
                          sectionList.length > 0 &&
                          sectionList[0].Type == 1 &&
                          sectionList[0].CriteriaCount > 0 && (
                            <th colSpan={sectionList[0].CriteriaCount}>
                              GATEWAY
                            </th>
                          )}
                        <th
                          colSpan={
                            criteriaList.length -
                            (programDashboardData.GatewayCount > 0
                              ? programDashboardData.GatewayCount
                              : 0)
                          }
                        >
                          CRITERIA
                        </th>
                        <th colSpan={7}></th>
                      </tr>
                      <tr className="h-41">
                        <th className="clip-box" colSpan={2}>
                          {/* <div className="flex-hold">
                          <span></span>
                          <a
                            className="show-summary"
                            onClick={(e) => {
                              setShowSummaryView(true);
                            }}
                          >
                            Summary
                          </a>
                        </div> */}
                        </th>
                        {sectionList &&
                          sectionList.map((item: any, index: any) => (
                            <React.Fragment key={"sectionheading" + index}>
                              {item.CriteriaCount > 0 && (
                                <th colSpan={item.CriteriaCount}>
                                  {item.ShortTitle}&nbsp;
                                  {item.Type == 2 && (
                                    <>
                                      {item.Value?.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                      })}
                                      %
                                    </>
                                  )}
                                </th>
                              )}
                            </React.Fragment>
                          ))}
                        <th>Total POT</th>
                        <th colSpan={6}>$ PAY-OUT</th>
                      </tr>
                      <tr>
                        <th className="clip-box" colSpan={2}></th>
                        {criteriaList &&
                          criteriaList.map((item: any, index: any) => (
                            <React.Fragment key={"criteriaheading" + index}>
                              <th>{item.Title}</th>
                            </React.Fragment>
                          ))}
                        <th colSpan={1}>All Brands</th>
                        <th colSpan={2}>PFI Brand 3</th>
                        <th colSpan={2}>PFI Brand 4</th>
                        <th colSpan={2}>All Brands</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importerList &&
                        importerList.map((item: any, index: any) => (
                          <React.Fragment key={"importerscorecard" + index}>
                            <tr>
                              <td>{item.MarketName}</td>
                              <td>
                                <div className="flex-td-in">
                                  {item.DealerName}
                                  {/* <a
                                  className=""
                                  title="View"
                                  href={
                                    "scorecard?pid=" +
                                    programDashboardFilter.ProgramID +
                                    "&qid=" +
                                    programDashboardFilter.QuarterID +
                                    "&scid=" +
                                    item.PID //+"&dlid=" + item.PFIDealerID
                                  }
                                >
                                  <img
                                    src="images/eye-blue.svg"
                                    width={20}
                                    height={20}
                                  />
                                </a> */}
                                </div>
                              </td>

                              {criteriaList &&
                                criteriaList.map(
                                  (criteriaItem: any, criteriaIndex: any) => (
                                    <React.Fragment
                                      key={
                                        "criteriascorecarddata" +
                                        index +
                                        "" +
                                        criteriaIndex
                                      }
                                    >
                                      <td
                                        className={
                                          item[criteriaItem.Title + "Class"]
                                        }
                                      >
                                        {item[criteriaItem.Title + "Icon"] !=
                                          "" && (
                                          // <img
                                          //   src={
                                          //     item[criteriaItem.Title + "Icon"]
                                          //   }
                                          //   width={18}
                                          //   height={19}
                                          // />

                                          <>
                                            {item[
                                              criteriaItem.Title + "Icon"
                                            ] == "images/exception.svg" && (
                                              <>&#9888;</>
                                            )}

                                            {item[
                                              criteriaItem.Title + "Icon"
                                            ] == "images/hold.svg" && (
                                              <>&#129306;</>
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </React.Fragment>
                                  )
                                )}
                              <td className="text-right-m">
                                $
                                {item.POT?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.JaguarFinalPayoutInUSD?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.JaguarExceptionPayout?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.LandRoverFinalPayoutInUSD?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.LandRoverExceptionPayout?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </td>
                              <td className="text-right-m">
                                $
                                {item.FinalPayout?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                              <td className="text-right-m">
                                $
                                {(
                                  item.JaguarExceptionPayout +
                                  item.LandRoverExceptionPayout
                                )?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}

                      <tr></tr>
                      <tr></tr>
                      <tr></tr>
                      <tr>
                        <th className="ib-red"></th>
                        <th colSpan={2}>Direct Fail</th>
                        <th className="ib-blue">&#9888;</th>
                        <th colSpan={2}>Exception raised</th>
                        <th className="ib-blue">&#129306;</th>
                        <th colSpan={3}>
                          Exception granted with conditional hold
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={10}></th>
                      </tr>
                      <tr>
                        <th className="ib-green"></th>
                        <th colSpan={2}>Direct pass on NA</th>
                        <th className="ib-red">&#9888;</th>
                        <th colSpan={2}>Exception rejected</th>
                        <th className="ib-red">&#129306;</th>
                        <th colSpan={3}>Conditional hold failed</th>
                      </tr>
                      <tr>
                        <th colSpan={10}></th>
                      </tr>
                      <tr>
                        <th colSpan={3}></th>
                        <th className="ib-amber">&#9888;</th>
                        <th colSpan={2}>Exception approved</th>
                        <th className="ib-amber">&#129306;</th>
                        <th colSpan={3}>Conditional hold passed</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            <div className="grid-legends">
              <div className="ib-l-box">
                <span className="ib-box-spn ib-red"></span>
                <span>Direct Fail</span>
              </div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-blue">
                  <img src="images/exception.svg" width={12} height={12} />
                </span>
                <span>Exception raised</span>
              </div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-blue">
                  <img src="images/hold.svg" width={12} height={12} />
                </span>
                <span>Exception granted with conditional hold</span>
              </div>

              <div className="ib-l-box">
                <span className="ib-box-spn ib-green"></span>
                <span>Direct pass or NA</span>
              </div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-red">
                  <img src="images/exception.svg" width={12} height={12} />
                </span>
                <span>Exception rejected</span>
              </div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-red">
                  <img src="images/hold.svg" width={12} height={12} />
                </span>
                <span>Conditional hold failed</span>
              </div>
              <div></div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-amber">
                  <img src="images/exception.svg" width={12} height={12} />
                </span>
                <span>Exception approved</span>
              </div>
              <div className="ib-l-box">
                <span className="ib-box-spn ib-box-spn-flex ib-amber">
                  <img src="images/hold.svg" width={12} height={12} />
                </span>
                <span>Conditional hold passed</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProgramDashboardV2;
